<div class="rs-newsletter style1 orange-color mb--90 sm-mb-0 sm-pb-70">
  <div class="container">
    <div class="newsletter-wrap">
      <div class="row y-middle">
        <div class="col-lg-6 col-md-12 md-mb-30">
          <div class="content-part">
            <div class="sec-title">
              <div class="title-icon md-mb-15">
                <img src="assets/images/newsletter.png" alt="images">
              </div>
              <h2 class="title mb-0 white-color">Subscribe to Newsletter</h2>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <form class="newsletter-form" [formGroup]="subscribeForm" (ngSubmit)="onSubmit()">
            <input type="email" name="email" placeholder="Enter Your Email" formControlName="emailAddress">
            <button type="submit" [disabled]="!subscribeForm.valid || isLoad" [attr.aria-busy]="isLoad">
              <span *ngIf="isLoad" class="btn-spinner" aria-hidden="true"></span>
              {{ isLoad ? 'Submitting...' : 'Submit' }}
            </button>
          </form>
          <div *ngIf="isFieldValid('emailAddress')" class="alert alert-danger mt-10 mb-0">
            Enter a valid email address
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
